export class Constants {
   public static CONVENIO_MULTILARETAL: string = "4";
   public static  INSCRIPTO: string = "3";
   public static  EXENTO: string = "2";
   public static NO_INCRIPTO: string = '1';
   public static REGIMEN_SIMPLIFICADO = "5";
}

export class MultilateralAgreement{
   public static SYSTEM_PADRON_WEB : string = 'Constancia de sistema padron web';
   public static CM05 : string = 'CM05';
}

export class DocumentId{
   public static DNI_FRENTE : number = 1;
   public static ACTA_DE_DESIGNACION_DE_AUTORIDADES : number = 2;
   public static ESTATUTO_O_CONTRATO_SOCIAL : number = 3;
   public static DNI_PRESIDENTE_FRENTE : number = 4;
   public static DNI_INTEGRANTE : number = 5;
   public static IMPUESTO_CONTRATO_LOCATION : number = 6;
   public static EXENTO_RESOLUCION : number = 7;
   public static CONSTANCIA_IIBB : number = 8;
   public static IIBB_CM05 : number = 9;
   public static IIBB_CONSTANCIA_PADRON : number = 10;
   public static REBA : number = 11;
   public static FOTO_COMERCIO : number = 12;
   public static IIBB_ACUSE_RECIBO : number = 13;
   public static CONSTANCIA_CUIL : number = 14;
   public static DNI_DORSO : number = 18;
   public static PODER_APODERADO: number = 19;
   public static DNI_PRESIDENTE_DORSO : number = 20;
   public static IMPUESTO_MUNICIPAL: number = 32;
}

export class CreateFile{
   public static ONE_FILE: boolean = true;
}

export enum IibbCategory {
   NoInscripto = 1,
   Exento = 2,
   InscriptoLocal = 3,
   ConvenioMultilateral = 4,
   RegimenSimplificado = 5,
}

export class DocKey{
   public static DNI_FRENTE : string = 'DniFrenteSolicitante';
   public static DNI_ATRAS : string = 'DniAtrasSolicitante';
   public static DNI_P_FRENTE : string = 'DniFrenteAtrasSolicitante';
   public static DNI_P_ATRAS : string = 'DniPreAtrasSolicitante';
   public static DNI_O_FRENTE : string = 'DniFrenteOtherSolicitante';
   public static DNI_O_ATRAS : string = 'DniAtrasOtherSolicitante';
   public static ACTA_DE_DESIGNACION_DE_AUTORIDADES : string = 'ActaDeDesignaciónDeAutoridades';
   public static ESTATUTO_O_CONTRATO_SOCIAL : string = 'EstatutooContratoSocial';
   public static IMPUESTO_CONTRATO_LOCATION : string = 'ImpuestoContratoLocation';
   public static EXENTO_RESOLUCION : string = 'ExentoResolucion';
   public static CONSTANCIA_IIBB :string = 'ConstanciaIIBB';
   public static IIBB_CM05 : string = 'IIBBCm05';
   public static IIBB_CONSTANCIA_PADRON : string = 'IIBBContanciaPadron';
   public static REBA :string = 'Reba'
   public static FOTO_COMERCIO : number = 12;
   public static IIBB_ACUSE_RECIBO : string = 'IIBBAcuseRecibo';
   public static CONSTANCIA_CUIL  :string = 'ConstanciaCuil';
   public static PODER_APODERADO: string = 'PoderApoderado';
   public static IMPUESTO_MUNICIPAL: string = 'ImpuestoMunicipal';
}

export const NameFileRegex = /^[a-zA-Z0-9_\-() .]+$/;

